var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.7281V5.07812L18.75 15.9031V23.1198L6.25 15.9031V30.3365L0 26.7281Z",
    fill: "#00B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.9031L37.5 5.07812V26.7281L25 33.9448L18.75 30.3365L31.25 23.1198V15.9031L18.75 23.1198V15.9031Z",
    fill: "#0081CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 30.3364V37.5531L31.25 44.7698V37.5531L18.75 30.3364Z",
    fill: "#00B0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 44.7698L50 33.9448V19.5115L43.75 23.1198V30.3365L31.25 37.5531V44.7698ZM43.75 15.9031V8.68646L50 5.07812V12.2948L43.75 15.9031Z",
    fill: "#0081CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/mui.565a724fb3b3fb0f7d1156365d64ee0d.svg";
export { ForwardRef as ReactComponent };